<button id="btn-reset-{{control.element.id}}"
        class="btn btn-primary btn-assessor"
        style="margin-top: 10px"
        (click)="handleResetClicked()">{{control.element.label}}</button>
